
// TODO: replace with the API data once achievements, merchandise and rankings endpoints are available (mirrors the launchpad template)

export interface IAchievement {
    year: number;
    icon: string;
    desc: string;
    title: string;
}

export interface IMerchItem {
    id: number;
    img: string;
    name: string;
    price: number;
    badge: string | null;
}

export interface IRankingEntry {
    rank: number;
    team: string;
    flag: string;
    game: string;
    wins: number;
    draws: number;
    losses: number;
    points: number;
    country: string;
    isOurs: boolean;
    form: ("W" | "L" | "D")[];
}

export const ACHIEVEMENTS: IAchievement[] = [
    { year: 2025, title: "Chess Winner", icon: "fa fa-trophy", desc: "Led the team with 8 goals and 11 assists throughout the tournament." },
    { year: 2025, title: "Call Of Duty Mobile MVP", icon: "fa fa-star", desc: "Named the league's most valuable player for the second consecutive season." },
    { year: 2024, title: "Golden Boot", icon: "fa fa-shoe-prints", desc: "Finished as top scorer with 31 goals in a single league season." },
    { year: 2024, title: "Fortnite Champion", icon: "fa fa-medal", desc: "Scored the winning penalty in the final against rivals Dynamo United." },
    { year: 2023, title: "World's Best Player", icon: "fa fa-globe", desc: "Awarded the prestigious Balondor prize by international football federation." },
    { year: 2023, title: "International Cup Winner", icon: "fa fa-medal", desc: "Guided Brazil to glory in the summer international tournament." },
    { year: 2022, title: "U23 World Cup Winner", icon: "fa fa-award", desc: "Scored a hat-trick in the final to become tournament top scorer." },
    { year: 2021, title: "Best Young Player", icon: "fa fa-certificate", desc: "Recognized as the world's best player under 21." },
];

export const MERCH: IMerchItem[] = [
    { id: 1, name: "Home Jersey 2025/26", price: 89.99, img: "https://images.unsplash.com/photo-1620794108219-aedbde4e6fb0?w=400&q=80", badge: "New" },
    { id: 2, name: "Training Kit Set", price: 64.99, img: "https://images.unsplash.com/photo-1599481238640-4c1288750d7a?w=400&q=80", badge: null },
    { id: 3, name: "Signed Match Ball", price: 199.99, img: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400&q=80", badge: "Limited" },
    { id: 4, name: "Signature Hoodie", price: 54.99, img: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=400&q=80", badge: null },
    { id: 5, name: "Away Jersey 2025/26", price: 89.99, img: "https://images.unsplash.com/photo-1571945192063-40f7fd5f7a49?w=400&q=80", badge: null },
    { id: 6, name: "Cap Collection", price: 29.99, img: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80", badge: "Hot" },
];

export function buildRankings(displayName: string): IRankingEntry[] {
    return [
        { rank: 1, team: "Bayern Fusion", flag: "🇩🇪", country: "Germany", game: "Chess", wins: 22, losses: 3, draws: 5, points: 71, form: ["W", "W", "D", "W", "W"], isOurs: false },
        { rank: 2, team: "Napoli Stars", flag: "🇮🇹", country: "Italy", game: "Chess", wins: 20, losses: 5, draws: 5, points: 65, form: ["W", "L", "W", "W", "D"], isOurs: false },
        { rank: 3, team: displayName, flag: "🇧🇷", country: "Brazil", game: "Chess", wins: 19, losses: 4, draws: 7, points: 64, form: ["W", "W", "W", "D", "W"], isOurs: true },
        { rank: 4, team: "Celtic Knights", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", country: "Scotland", game: "Chess", wins: 18, losses: 6, draws: 6, points: 60, form: ["D", "W", "W", "L", "W"], isOurs: false },
        { rank: 5, team: "Sporting FC", flag: "🇵🇹", country: "Portugal", game: "Chess", wins: 17, losses: 7, draws: 6, points: 57, form: ["W", "D", "L", "W", "W"], isOurs: false },
        { rank: 6, team: "Ajax Elite", flag: "🇳🇱", country: "Netherlands", game: "Chess", wins: 16, losses: 8, draws: 6, points: 54, form: ["L", "W", "D", "W", "W"], isOurs: false },
        { rank: 1, team: displayName, flag: "🇧🇷", country: "Brazil", game: "Call Of Duty Mobile", wins: 21, losses: 4, draws: 5, points: 68, form: ["W", "W", "W", "W", "D"], isOurs: true },
        { rank: 2, team: "Real Tigres", flag: "🇲🇽", country: "Mexico", game: "Call Of Duty Mobile", wins: 19, losses: 5, draws: 6, points: 63, form: ["W", "D", "W", "L", "W"], isOurs: false },
        { rank: 3, team: "Sevilla FC", flag: "🇪🇸", country: "Spain", game: "Call Of Duty Mobile", wins: 18, losses: 6, draws: 6, points: 60, form: ["W", "W", "D", "W", "L"], isOurs: false },
        { rank: 4, team: "Fiorentina FC", flag: "🇮🇹", country: "Italy", game: "Call Of Duty Mobile", wins: 16, losses: 7, draws: 7, points: 55, form: ["L", "W", "W", "D", "W"], isOurs: false },
        { rank: 1, team: "Dynamo United", flag: "🇺🇦", country: "Ukraine", game: "Fortnite", wins: 20, losses: 4, draws: 6, points: 66, form: ["W", "W", "L", "W", "W"], isOurs: false },
        { rank: 2, team: displayName, flag: "🇧🇷", country: "Brazil", game: "Fortnite", wins: 18, losses: 6, draws: 6, points: 60, form: ["W", "D", "W", "L", "W"], isOurs: true },
        { rank: 3, team: "Bayern Fusion", flag: "🇩🇪", country: "Germany", game: "Fortnite", wins: 16, losses: 7, draws: 7, points: 55, form: ["L", "W", "W", "D", "W"], isOurs: false },
        { rank: 4, team: "Ajax Elite", flag: "🇳🇱", country: "Netherlands", game: "Fortnite", wins: 14, losses: 9, draws: 7, points: 49, form: ["D", "W", "L", "W", "D"], isOurs: false },
    ];
}
